import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist';
import { combineReducers } from '@reduxjs/toolkit';
import { emptySplitApi } from '../app/services/emptySliceApi';
import { persistedAuthReducer } from './authSlice';
import popupReducer from "./popUpSlice";


const reducer = combineReducers({
  auth: persistedAuthReducer,
  popup: popupReducer,
  [emptySplitApi.reducerPath]: emptySplitApi.reducer
})

// const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      emptySplitApi.middleware
    ])
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store);